import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "sonner";
import { addNewBlogCategory, updateBlogCategory } from "../../services/axios/apiManager";
import LoadingSpinner from "../../Components/spinner";

const AddBlogCategoryModal = ({ show, onHide, onSuccess, editData }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        title: editData.title || "",
        slug: editData.slug || "",
      });
    } else {
      setFormData({ title: "", slug: "" });
    }
  }, [editData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "title" && !prev.slug && !editData) {
        newData.slug = value
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
      }
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.slug) {
      toast.error("Title and slug are required");
      return;
    }

    setLoading(true);
    try {
      let response;
      if (editData) {
        response = await updateBlogCategory({ id: editData.id, ...formData });
      } else {
        response = await addNewBlogCategory(formData);
      }

      if (response?.data?.success) {
        toast.success(editData ? "Category updated successfully" : "Category added successfully");
        if (!editData) setFormData({ title: "", slug: "" });
        if (onSuccess) onSuccess(response.data.data);
        onHide();
      } else {
        toast.error(response?.data?.message || "Failed to save category");
      }
    } catch (error) {
      console.error("Error saving category:", error);
      toast.error("An error occurred while saving the category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="blog-category-modal">
      <Modal.Header closeButton className="bg-dark text-light border-secondary">
        <Modal.Title>{editData ? "Edit Category" : "Add New Category"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="bg-dark text-light">
          <Form.Group className="mb-3" controlId="categoryTitle">
            <Form.Label>Category Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              placeholder="e.g. Technology"
              className="bg-dark text-light border-secondary"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="categorySlug">
            <Form.Label>Slug</Form.Label>
            <Form.Control
              type="text"
              name="slug"
              placeholder="e.g. technology"
              className="bg-dark text-light border-secondary"
              value={formData.slug}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-secondary">
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={loading}>
            {loading ? <LoadingSpinner size="sm" /> : (editData ? "Save Changes" : "Add Category")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddBlogCategoryModal;
